import React from 'react'
import Layout from '../DashboardLayout'

const TransmitProfile = () => {
  return (
    <Layout>TransmitProfile</Layout>
  )
}

export default TransmitProfile